import { render, staticRenderFns } from "./override_button.vue?vue&type=template&id=b897b6e8&"
import script from "./override_button.vue?vue&type=script&lang=js&"
export * from "./override_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports